import React from 'react';
import SearchAreaControl from './SearchAreaControl';
import { Button, Row } from 'react-bootstrap';
import ParcelTable from 'components/common/advance-table/ParcelTable';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { setRegionFocus } from 'reducers/livingCarbonGrantReducer';

const DefinePropertyBoundary = ({
  errors,
  setError,
  clearErrors,
  selectedLandParcels
}) => {
  const dispatch = useDispatch();
  return (
    <>
      <h5>Define Property Boundary</h5>
      <SearchAreaControl />
      <div className="my-3">
        <Button
          className="mx-1"
          onClick={() => {
            dispatch(setRegionFocus(0)); // north coast
          }}
        >
          North Coast
        </Button>
        <Button
          className="mx-1"
          onClick={() => {
            dispatch(setRegionFocus(1)); // mid coast
          }}
          variant="info"
        >
          Mid Coast
        </Button>
        <Button
          className="mx-1"
          onClick={() => {
            dispatch(setRegionFocus(2)); // riverina
          }}
          variant="success"
        >
          Riverina
        </Button>
      </div>
      <ParcelTable
        errors={errors}
        setError={setError}
        clearErrors={clearErrors}
        selectedLandParcels={selectedLandParcels}
      ></ParcelTable>
    </>
  );
};

DefinePropertyBoundary.propTypes = {
  errors: PropTypes.object.isRequired,
  setError: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  selectedLandParcels: PropTypes.array
};

export default DefinePropertyBoundary;
